import React from "react";
import { Textarea } from "components/ui/textarea"
import styled, { keyframes } from "styled-components";

const expandBorder = keyframes`
  from {
    height: 0;
  }
  to {
    height: 100%;
  }
`;

const Container = styled.div`
  position: relative;
  margin-top: 1rem;
  padding-left: 1em;

  &::before {
    content: "";
    position: absolute;
    left: 0;
    top: 0;
    width: 4px;
    height: 0;
    background-color: #2D70E2;
    border-radius: 2px;
    animation: ${expandBorder} 0.1s ease-out forwards;
  }
`;


const slideIn = keyframes`
  from {
    transform: translateX(-20px);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
`;


const Label = styled.div`
  display: inline-block;
  opacity:0;
  animation: ${slideIn} 0.2s ease-out forwards;
  animation-delay: 0.1s; /* Wait for the border animation to finish */
`;

export default function QuestionFollowup({ question, currentAnswer, onAnswerChange }) {
  return (
    <Container>
     <Label>
        <strong>Follow-up:</strong> {question.label}
      </Label>
      <br />
      <Textarea
        rows={3}
        value={currentAnswer}
        onChange={(e) => onAnswerChange(question.uniqueId, e.target.value)}
        style={{
          width: "100%",
          marginTop: "8px",
          padding: "10px",
          borderRadius: "4px",
          border: "1px solid #ddd",
          fontFamily: "Raleway, sans-serif",
          backgroundColor: "#fff",
        }}
      />
      {question.aiDriven && (
        <p style={{ marginTop: "0.5rem", fontStyle: "italic", fontSize: "0.9rem" }}>
          AI Prompt: {question.aiPrompt}
        </p>
      )}
    </Container>
  );
}
